import { RemoteConfigUtils } from '~/utils/RemoteConfigUtils';
import { calculateRateFloor, resolveRateFloorPercentage } from '../utils/rateFloor';

interface IUseRateFloorParams {
  professionCode?: string;
  officeState?: string;
  averageRate: number;
  apiMin: number;
}

interface IUseRateFloorResult {
  /** The computed rate floor for the profession: max($18, floor(average × pct)). */
  rateFloor: number;
  /** Lowest selectable rate: the larger of the API-provided min and the rate floor. */
  effectiveMin: number;
}

/**
 * Resolves the lowest hourly rate selectable for a profession by combining the
 * API-provided minimum with a configurable floor (a share of the recommended
 * rate). Percentages come from remote config, falling back to safe defaults.
 */
export const useRateFloor = ({
  professionCode,
  officeState,
  averageRate,
  apiMin,
}: IUseRateFloorParams): IUseRateFloorResult => {
  const percentage = professionCode
    ? resolveRateFloorPercentage(
        RemoteConfigUtils.getRateFloorPercentages(),
        professionCode,
        officeState,
      )
    : undefined;
  const rateFloor = calculateRateFloor(averageRate, percentage);
  const effectiveMin = Math.max(apiMin, rateFloor);

  return { rateFloor, effectiveMin };
};
